var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJadelizard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4497 33.9118L6.50015 41.3404L6.33354 46.2185L25.3897 33.9118L17.4497 33.9118Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9379 28.5219H29.839L27.0698 31.0002L24.3006 33.6087L17.1797 33.6089L21.1357 30.0871L24.3006 27.348L27.0698 25.0002H40.1247L46.4544 27.7393H53.1797V31.2611H45.6632L38.9379 28.5219Z",
    fill: "#12B16E",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJadelizard);
export default __webpack_public_path__ + "static/media/jade lizard.f0545c44b85abcdb021bb10be152c7ff.svg";
export { ForwardRef as ReactComponent };